import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

import { CertificateRepository }
from '../../../domain/repositories/certificate.repository';

import { DocumentSystemGenerateImplementationRepositoryMapper }
from './mappers/document-system-generate.repository.mapper';
import { DataDocumentSystemGenerateModel, DocumentSystemGenerateModel } from '../../../domain/models/certificate/document-system-generate.model';
import { DocumentSystemGenerateEntity } from './entities/document-system-generate.entity';

@Injectable({
  providedIn: 'root',
})
export class CertificateImplementationRepository
extends CertificateRepository {

  documentsystemgenerate =
  new DocumentSystemGenerateImplementationRepositoryMapper();

  url = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) {
    super();
  }


  override getDocumentsSystemGenerates(): Observable<DocumentSystemGenerateModel> {
    return this.http.get<DocumentSystemGenerateEntity>(`${this.url}/DocumentosSistemaGenerado/GetAll`)
      .pipe(map(this.documentsystemgenerate.mapFrom));
  }


  override insertDocumentSystemGenerate( params: DataDocumentSystemGenerateModel ): Observable<DocumentSystemGenerateModel> {
    return this.http.post<DocumentSystemGenerateEntity>( `${this.url}/DocumentosSistemaGenerado/Insert`, params )
      .pipe(
        map( this.documentsystemgenerate.mapFrom )
      );
  }

  override updateDocumentSystemGenerate( params: DataDocumentSystemGenerateModel): Observable<DocumentSystemGenerateModel> {

    return this.http.put<DocumentSystemGenerateEntity>( `${this.url}/DocumentosSistemaGenerado/Update`, params)
      .pipe(map( this.documentsystemgenerate.mapFrom )
      );
  }

}